import { TabsTypes } from "../types";

export const tabsTypeChecher = (type) => {
    return function(element) {
        return !!element.type && element.type.tabsRole === type;
    }
}

export const isTab = tabsTypeChecher(TabsTypes.Tab);
export const isTabList = tabsTypeChecher(TabsTypes.TabList);
export const isTabPanel = tabsTypeChecher(TabsTypes.TabPanel);
